/* =============================================================================
   FTB Product Finder — Quiz, scoring, results, add-to-cart
   ============================================================================= */
(function () {
  'use strict';

  /* ── Product data set by inline Liquid script before this defer file runs ── */
  var PD    = window.FTBPFData    || {};
  var DISC  = PD._discount        || {};
  var META  = PD._meta            || {};
  var AVAIL = PD._availability    || {};
  if (!window.FTBPFData) {
    console.warn('[FTB Product Finder] window.FTBPFData not set — check section Liquid.');
  }

  /* ── Questions ── */
  var QUESTIONS = [
    {
      id: 'experience',
      text: 'What best describes you?',
      answers: [
        { id: 'beginner',  text: 'New to detailing',           icon: '🌱' },
        { id: 'hobbyist',  text: 'I enjoy washing properly',   icon: '🚿' },
        { id: 'pro',       text: 'Detail regularly / pro',     icon: '⭐' }
      ]
    },
    {
      id: 'vehicle',
      text: 'What vehicle are you cleaning?',
      answers: [
        { id: 'daily',       text: 'Daily driver',              icon: '🚗' },
        { id: 'show',        text: 'Weekend / show car',        icon: '🏆' },
        { id: 'workhorse',   text: 'Workhorse / off-road',      icon: '🚙' },
        { id: 'performance', text: 'Performance car',           icon: '🏎' }
      ]
    },
    {
      id: 'protection',
      text: 'Does your paint have protection?',
      answers: [
        { id: 'coated',  text: 'Ceramic coated',   icon: '💎' },
        { id: 'wax',     text: 'Wax / sealant',    icon: '✨' },
        { id: 'none',    text: 'No protection',    icon: '⚡' },
        { id: 'unsure',  text: 'Not sure',         icon: '❓' }
      ]
    },
    {
      id: 'frustration',
      text: "What's your biggest frustration?",
      answers: [
        { id: 'heavy_dirt', text: 'Heavy dirt & grime',      icon: '💪' },
        { id: 'brake_dust', text: 'Brake dust & fallout',    icon: '🔴' },
        { id: 'gloss',      text: 'Lack of gloss',           icon: '💫' },
        { id: 'quick',      text: 'Quick maintenance',       icon: '⚡' },
        { id: 'interior',   text: 'Interior mess',           icon: '🪑' },
        { id: 'paint',      text: 'Paint needs improvement', icon: '🎨' }
      ]
    },
    {
      id: 'wash_style',
      text: 'How do you want to wash?',
      answers: [
        { id: 'quick_easy',   text: 'Quick and easy',              icon: '⚡' },
        { id: 'proper',       text: 'Proper weekend wash',         icon: '🛁' },
        { id: 'max_gloss',    text: 'Maximum gloss',               icon: '💫' },
        { id: 'touchless',    text: 'Touchless / pre-wash focus',  icon: '🌊' }
      ]
    }
  ];

  /* ── Scoring: each answer adds/subtracts from product scores ── */
  var SCORING = {
    experience: {
      beginner:  { yeti_pro: 3, ogre: 2, hydra: 3, satan: -30, goblin: -30, cerburus: -10, cyclops_pro: 1 },
      hobbyist:  { yeti_pro: 2, ogre: 2, hydra: 2, griffin: 2, vampire: 2, cyclops_pro: 2, chimera: 1 },
      pro:       { yeti_pro: 1, satan: 2, cyclops_pro: 3, griffin: 3, goblin: 2, cerburus: 3, vulture: 2, chimera: 2 }
    },
    vehicle: {
      daily:       { yeti_pro: 2, ogre: 2, hydra: 2 },
      show:        { griffin: 3, chimera: 2, goblin: 2, satan: 1, drying_towel: 2, yeti_pro: 1 },
      workhorse:   { cyclops_pro: 3, vulture: 2, yeti_pro: 1, bigfoot: 2 },
      performance: { chimera: 2, griffin: 2, vampire: 3, cyclops_pro: 2, yeti_pro: 1 }
    },
    protection: {
      coated:  { chimera: 4, griffin: 2, ogre: 3, yeti_pro: 3, satan: -30, cyclops_pro: -1 },
      wax:     { ogre: 2, yeti_pro: 2, hydra: 2, griffin: 1 },
      none:    { hydra: 3, ogre: 2, yeti_pro: 2, satan: 2 },
      unsure:  { ogre: 2, hydra: 3, yeti_pro: 3 }
    },
    frustration: {
      heavy_dirt: { cyclops_pro: 4, yeti_pro: 2, ogre: 1 },
      brake_dust: { vampire: 4, vulture: 5, tyre_brush: 2, bigfoot: 1 },
      gloss:      { griffin: 4, goblin: 3, chimera: 3, satan: 2 },
      quick:      { chimera: 4, griffin: 2, hydra: 2, pump_sprayer: 1 },
      interior:   { oni: 4, buffalo: 3, bison: 3 },
      paint:      { cerburus: 4, goblin: 2 }
    },
    wash_style: {
      quick_easy: { hydra: 3, griffin: 2, chimera: 2, wash_brick: 1, pump_sprayer: 1 },
      proper:     { ogre: 3, vampire: 2, yeti_pro: 2, drying_towel: 2, tyre_brush: 1 },
      max_gloss:  { griffin: 4, goblin: 2, satan: 2, chimera: 2, drying_towel: 2 },
      touchless:  { cyclops_pro: 4, yeti_pro: 3, foam_lance: 3 }
    }
  };

  /* ── Display info (name, desc, category) ── */
  var INFO = {
    yeti_pro:    { name: 'Yeti Pro',      desc: 'pH-neutral pre-wash foam. Safe on all paint and protection.', cat: 'core', icon: '🧴' },
    ogre:        { name: 'Ogre',          desc: 'Gentle contact shampoo. Safe on coatings, wax and sealant.', cat: 'core', icon: '🧴' },
    satan:       { name: 'Satan',         desc: 'High-gloss strip shampoo for uncoated paint. Serious results.', cat: 'core', icon: '🧴' },
    cyclops_pro: { name: 'Cyclops Pro',   desc: 'Heavy-duty traffic film remover. Tackles the worst grime first.', cat: 'core', icon: '💪' },
    hydra:       { name: 'Hydra',         desc: 'Spray-on 3-month protection. Beginner-friendly and genuinely effective.', cat: 'core', icon: '🛡' },
    griffin:     { name: 'Griffin',       desc: 'Finishing spray wax. Adds gloss and light protection every wash.', cat: 'core', icon: '✨' },
    chimera:     { name: 'Chimera',       desc: 'Ceramic coating topper and quick detailer. Keep your coating glowing.', cat: 'core', icon: '💎' },
    goblin:      { name: 'Goblin',        desc: 'Show glaze for maximum depth and warmth. Enthusiasts only.', cat: 'upgrade', icon: '🏆' },
    cerburus:    { name: 'Cerburus',      desc: '3-in-1 compound, polish and protectant. Improves tired paint.', cat: 'upgrade', icon: '🎨' },
    vampire:     { name: 'Vampire',       desc: 'Regular wheel cleaner. Safe on all alloys, makes them pop.', cat: 'core', icon: '🔵' },
    vulture:     { name: 'Vulture',       desc: 'Iron fallout remover. Safe on coated vehicles — do not allow to dry.', cat: 'upgrade', icon: '🔴' },
    bigfoot:     { name: 'Bigfoot',       desc: 'Tyre and trim dressing. Long-lasting satin to gloss finish.', cat: 'upgrade', icon: '⚫' },
    oni:         { name: 'Oni',           desc: 'Interior dressing with light cleaning. Revives plastics and trim.', cat: 'upgrade', icon: '🪑' },
    buffalo:     { name: 'Buffalo',       desc: 'Leather cleaner. Lifts grime from leather without drying it out.', cat: 'upgrade', icon: '🐂' },
    bison:       { name: 'Bison',         desc: 'Leather conditioner. Use after Buffalo to keep seats supple.', cat: 'upgrade', icon: '🐂' },
    foam_lance:  { name: 'Foam Lance',    desc: 'More foam, less effort. Connects to any pressure washer.', cat: 'accessory', icon: '🌊' },
    drying_towel:{ name: 'Drying Towel',  desc: 'Large premium microfibre. Streak-free drying every time.', cat: 'accessory', icon: '🏁' },
    tyre_brush:  { name: 'Tyre Brush',    desc: 'Safe agitation for tyres and arches without scratching alloys.', cat: 'accessory', icon: '🖌' },
    pump_sprayer:{ name: 'Pump Sprayer',  desc: 'Dilute and apply product safely. Saves product, saves time.', cat: 'accessory', icon: '💧' },
    wash_brick:  { name: 'Wash Brick',    desc: 'Dense microfibre wash block. Easy to hold, gentle on paint.', cat: 'accessory', icon: '🧱' }
  };

  var ACCESSORIES = ['foam_lance', 'drying_towel', 'tyre_brush', 'pump_sprayer', 'wash_brick'];
  var UPGRADES    = ['goblin', 'cerburus', 'vulture', 'bigfoot', 'oni', 'buffalo', 'bison'];

  /* ── State ── */
  var answers        = {};
  var currentQ       = 0;
  var advancing      = false;
  var activeKit      = []; /* mutable core kit — items can be removed */
  var activeUpgrades = []; /* keys of currently ticked upgrades */

  /* ── Elements ── */
  var heroEl    = document.getElementById('ftb-pf-hero');
  var quizEl    = document.getElementById('ftb-pf-quiz');
  var resultsEl = document.getElementById('ftb-pf-results');
  var startBtn  = document.getElementById('ftb-pf-start');
  var backBtn   = document.getElementById('ftb-pf-back');
  var qWrap     = document.getElementById('ftb-pf-q-wrap');
  var progFill  = document.getElementById('ftb-pf-prog-fill');
  var progLabel = document.getElementById('ftb-pf-prog-label');
  var resInner  = document.getElementById('ftb-pf-res-inner');

  if (!heroEl || !quizEl || !resultsEl || !qWrap) {
    console.warn('[FTB Product Finder] Missing required elements:', { heroEl: heroEl, quizEl: quizEl, resultsEl: resultsEl, qWrap: qWrap });
    return;
  }

  /* ── Stage controller ── */
  function setStage(stage) {
    document.body.dataset.pfStage = stage;
  }

  /* Stamp data-pf-hide-during="quiz" on every Shopify section on this page
     except the Product Finder section itself and persistent chrome (nav/footer).
     Skipped in theme editor so sections stay selectable. */
  (function tagSectionsForQuiz() {
    if (window.Shopify && window.Shopify.designMode) return;
    var pfEl      = document.getElementById('ftb-pf');
    var skipTerms = ['header', 'footer', 'nav', 'announcement', 'cookie'];
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      /* Skip the section that contains the Product Finder */
      if (pfEl && sec.contains(pfEl)) return;
      var id = (sec.id || '').toLowerCase();
      if (skipTerms.some(function (t) { return id.indexOf(t) !== -1; })) return;
      sec.setAttribute('data-pf-hide-during', 'quiz');
    });
  }());

  setStage('landing');

  /* ── Start ── */
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      setStage('quiz');
      heroEl.style.display = 'none';
      quizEl.style.display = '';
      if (META.quiz_bg) {
        quizEl.style.backgroundImage    = 'url(' + META.quiz_bg + ')';
        quizEl.style.backgroundSize     = 'cover';
        quizEl.style.backgroundPosition = 'center';
      }
      showQuestion(0);
    });
  }

  /* ── Back ── */
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (currentQ > 0) showQuestion(currentQ - 1);
    });
  }

  /* ── Show question ── */
  function showQuestion(idx) {
    currentQ = idx;
    var q   = QUESTIONS[idx];
    var pct = Math.round((idx / QUESTIONS.length) * 100);

    if (progFill)  progFill.style.width  = pct + '%';
    if (progLabel) progLabel.textContent = 'Question ' + (idx + 1) + ' of ' + QUESTIONS.length;
    if (backBtn)   backBtn.style.display = idx > 0 ? '' : 'none';

    var html = '<p class="ftb-pf__q-text">' + esc(q.text) + '</p>' +
      '<div class="ftb-pf__answers">';
    q.answers.forEach(function (a) {
      var sel = answers[q.id] === a.id ? ' is-selected' : '';
      html += '<button class="ftb-pf__answer' + sel + '" data-q="' + q.id + '" data-a="' + a.id + '">' +
        '<span class="ftb-pf__answer-icon" aria-hidden="true">' + a.icon + '</span>' +
        '<span class="ftb-pf__answer-text">' + esc(a.text) + '</span>' +
        '<span class="ftb-pf__answer-check" aria-hidden="true">&#x2713;</span>' +
        '</button>';
    });
    html += '</div>';
    qWrap.innerHTML = html;

    qWrap.querySelectorAll('.ftb-pf__answer').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (advancing) return;
        advancing = true;
        answers[btn.dataset.q] = btn.dataset.a;
        btn.classList.add('is-selected');
        setTimeout(function () {
          advancing = false;
          if (currentQ < QUESTIONS.length - 1) {
            showQuestion(currentQ + 1);
          } else {
            renderResults();
          }
        }, 280);
      });
    });
  }

  /* ── Score calculation ── */
  function calcScores() {
    var scores = {};

    Object.keys(answers).forEach(function (qId) {
      var aId  = answers[qId];
      var qMap = SCORING[qId];
      if (!qMap) return;
      var aMap = qMap[aId];
      if (!aMap) return;
      Object.keys(aMap).forEach(function (prod) {
        scores[prod] = (scores[prod] || 0) + aMap[prod];
      });
    });

    /* Ensure fallback always present */
    scores.yeti_pro = Math.max(scores.yeti_pro || 0, 3);
    scores.ogre     = Math.max(scores.ogre     || 0, 2);

    var isBeginner = answers.experience === 'beginner';
    var isCoated   = answers.protection === 'coated';
    var isPro      = answers.experience === 'pro';

    /* Hard exclusions */
    if (isBeginner || isCoated) delete scores.satan;
    if (isBeginner)             { delete scores.goblin; scores.cerburus = Math.max(0, (scores.cerburus || 0) - 8); }

    /* Chimera vs Griffin: overlapping finishing products — keep only the better fit.
       Coated paint = Chimera (ceramic topper).
       Non-coated (none/wax/unsure) = Griffin (spray wax).
       This rule fires whenever both accumulate positive scores. */
    if (scores.chimera > 0 && scores.griffin > 0) {
      if (isCoated) {
        delete scores.griffin;
      } else {
        delete scores.chimera;
      }
    }

    /* One contact shampoo only */
    if (scores.ogre > 0 && scores.satan > 0) {
      if (scores.ogre >= scores.satan) delete scores.satan;
      else                             delete scores.ogre;
    }

    /* Bigfoot only if brake dust or workhorse path */
    if (answers.frustration !== 'brake_dust' && answers.vehicle !== 'workhorse') {
      delete scores.bigfoot;
    }

    /* Buffalo + Bison: pair or not at all */
    if (answers.frustration !== 'interior') {
      delete scores.buffalo;
      delete scores.bison;
    } else if (scores.buffalo || scores.bison) {
      scores.buffalo = Math.max(scores.buffalo || 0, 3);
      scores.bison   = Math.max(scores.bison   || 0, 3);
    }

    /* Remove zero/negative */
    Object.keys(scores).forEach(function (k) {
      if (scores[k] <= 0) delete scores[k];
    });

    return scores;
  }

  /* ── Availability check — false if out-of-stock or handle not mapped ── */
  function isAvailable(k) {
    if (AVAIL[k] === false) return false;
    var vid = PD[k] && parseInt(PD[k].id, 10);
    return !!(vid && vid > 0);
  }

  /* ── Shared ATC handler — used by both sticky and inline buttons ── */
  function fireAtc(btn) {
    var items      = [];
    var missingIds = [];

    activeKit.forEach(function (k) {
      var vid = PD[k] && parseInt(PD[k].id, 10);
      if (vid && vid > 0) items.push({ id: vid, quantity: 1 });
      else missingIds.push(k);
    });

    activeUpgrades.forEach(function (k) {
      var vid = PD[k] && parseInt(PD[k].id, 10);
      if (vid && vid > 0) items.push({ id: vid, quantity: 1 });
    });

    if (missingIds.length) {
      console.warn('[FTB PF] Products missing variant IDs:', missingIds);
    }
    console.log('[FTB PF] ATC payload:', JSON.stringify(items));

    if (!items.length) {
      btn.textContent = 'Set product handles in theme editor first';
      setTimeout(function () { btn.textContent = 'Add My Kit To Basket'; }, 3500);
      return;
    }

    btn.disabled    = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated',   { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:item-added'));
        btn.textContent = 'Added to basket ✓';
        btn.disabled    = false;
      })
      .catch(function (err) {
        console.error('[FTB PF] ATC failed. Error:', err, '| Payload:', items);
        btn.textContent = 'Could not add — try again';
        btn.disabled    = false;
      });
  }

  /* ── Render results — scaffolds DOM, then delegates to updateResultsState ── */
  function renderResults() {
    setStage('results');
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (META.results_bg) {
      resultsEl.style.backgroundImage    = 'url(' + META.results_bg + ')';
      resultsEl.style.backgroundSize     = 'cover';
      resultsEl.style.backgroundPosition = 'center';
    }

    if (progFill)  progFill.style.width  = '100%';
    if (progLabel) progLabel.textContent = 'Your kit is ready';

    quizEl.style.display    = 'none';
    resultsEl.style.display = '';

    var scores  = calcScores();
    var kitSize = { beginner: 4, hobbyist: 5, pro: 6 }[answers.experience] || 4;

    var sorted = Object.keys(scores)
      .filter(function (k) { return INFO[k]; })
      .filter(function (k) {
        if (!isAvailable(k)) {
          console.warn('[FTB PF] Excluded out-of-stock product: ' + k);
          return false;
        }
        return true;
      })
      .sort(function (a, b) { return scores[b] - scores[a]; });

    var core     = [];
    var upgrades = [];
    var accs     = [];

    sorted.forEach(function (k) {
      var p = PD[k];
      if (!p || !p.id) {
        console.warn('[FTB PF] No variant ID for "' + k + '". Set the correct Shopify product handle in theme editor.');
      }
      if (ACCESSORIES.indexOf(k) !== -1) accs.push(k);
      else if (UPGRADES.indexOf(k) !== -1) upgrades.push(k);
      else core.push(k);
    });

    /* Set mutable state */
    activeKit      = core.slice(0, kitSize);
    activeUpgrades = [];

    var coreSpill   = core.slice(kitSize);
    var upgradeList = upgrades.concat(coreSpill).slice(0, 6);
    var accList     = accs.slice(0, 3);
    var allUpgrades = upgradeList.concat(accList);

    /* ── Static scaffold HTML ── */
    var kitHeading = META.results_heading || 'Your Recommended Wash Kit';
    var html = '<div class="ftb-pf__res-inner">';

    html += '<h2 class="ftb-pf__res-heading ftb-pf__res-reveal" style="margin-top:40px;">' + esc(kitHeading) + '</h2>';
    html += '<p class="ftb-pf__kit-count" id="ftb-pf-kit-count"></p>';
    html += '<div id="ftb-pf-cards-wrap" class="ftb-pf__cards"></div>';

    /* Why this setup works — based on initial recommendation */
    var whyLines = buildWhy(activeKit, answers);
    html += '<h3 class="ftb-pf__res-heading">Why This Setup Works</h3>';
    html += '<div class="ftb-pf__why"><ul class="ftb-pf__why-list">';
    whyLines.forEach(function (l) { html += '<li class="ftb-pf__why-item">' + esc(l) + '</li>'; });
    html += '</ul></div>';

    /* Kit in action — visual 3-card strip */
    html += '<h3 class="ftb-pf__res-heading">Your Kit In Action</h3>';
    html += '<div class="ftb-pf__kit-in-action">';
    [
      { img: META.prewash_img,  title: META.prewash_title  || 'Pre-wash',        text: META.prewash_text  || 'Break down dirt before touching the paint.' },
      { img: META.contact_img,  title: META.contact_title  || 'Contact wash',     text: META.contact_text  || 'Safely remove remaining grime with the right shampoo.' },
      { img: META.finish_img,   title: META.finish_title   || 'Protect & finish', text: META.finish_text   || 'Add gloss, protection and the final finish.' }
    ].forEach(function (card) {
      html += '<div class="ftb-pf__kia-card">';
      if (card.img) {
        html += '<div class="ftb-pf__kia-img"><img src="' + esc(card.img) + '" alt="' + esc(card.title) + '" loading="lazy"></div>';
      }
      html += '<div class="ftb-pf__kia-body">' +
        '<p class="ftb-pf__kia-title">' + esc(card.title) + '</p>' +
        '<p class="ftb-pf__kia-text">'  + esc(card.text)  + '</p>' +
        '</div></div>';
    });
    html += '</div>';

    /* Discount callout */
    if (DISC.show !== false && DISC.code) {
      html += '<div class="ftb-pf__disc">' +
        '<p class="ftb-pf__disc-headline">' + esc(DISC.headline || '15% off this recommended kit') + '</p>' +
        '<div class="ftb-pf__disc-row">' +
        '<span class="ftb-pf__disc-code">' + esc(DISC.code) + '</span>' +
        '<button type="button" class="ftb-pf__disc-copy" id="ftb-pf-copy-btn" data-code="' + esc(DISC.code) + '">Copy code</button>' +
        '</div>' +
        (DISC.subtext ? '<p class="ftb-pf__disc-sub">' + esc(DISC.subtext) + '</p>' : '') +
        '</div>';
    }

    /* Upgrades */
    if (allUpgrades.length) {
      html += '<h3 class="ftb-pf__res-heading">Recommended Upgrades</h3>';
      html += '<p class="ftb-body ftb-body--sm" style="color:var(--ftb-text2);margin-bottom:16px;">Tick anything you want added to your basket.</p>';
      html += '<div class="ftb-pf__upgrades">';
      allUpgrades.forEach(function (k) { html += upgradeHtml(k); });
      html += '</div>';
    }

    /* How to use — dynamic placeholder updated by updateResultsState */
    html += '<h3 class="ftb-pf__res-heading">How To Use This Kit</h3>';
    html += '<div id="ftb-pf-steps-wrap" class="ftb-pf__steps"></div>';

    /* In-page ATC — shares fireAtc(), no logic duplication */
    html += '<div class="ftb-pf__inline-atc">' +
      '<button type="button" class="ftb-btn ftb-btn--primary ftb-btn--lg ftb-btn--full" id="ftb-pf-atc-inline">Add My Kit To Basket</button>' +
      '<p class="ftb-pf__atc-note" style="text-align:center;">Core kit added. Ticked upgrades included.</p>' +
      '</div>';

    html += '</div>'; /* /res-inner */

    html += '<div class="ftb-pf__atc-bar" id="ftb-pf-atc-bar">' +
      '<div class="ftb-pf__atc-inner">' +
      '<button type="button" class="ftb-btn ftb-btn--primary ftb-btn--lg ftb-btn--full" id="ftb-pf-atc">Add My Kit To Basket</button>' +
      '<p class="ftb-pf__atc-note">Core kit added. Ticked upgrades included.</p>' +
      '</div></div>';

    html += '<button type="button" class="ftb-pf__restart" id="ftb-pf-restart">Start over</button>';

    resInner.innerHTML = html;

    /* ── Bind: copy button ── */
    var copyBtn = document.getElementById('ftb-pf-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.code;
        var succeed = function () {
          copyBtn.textContent = 'Copied ✓';
          copyBtn.style.color       = 'var(--ftb-acid)';
          copyBtn.style.borderColor = 'var(--ftb-acid)';
          setTimeout(function () {
            copyBtn.textContent       = 'Copy code';
            copyBtn.style.color       = '';
            copyBtn.style.borderColor = '';
          }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(succeed).catch(function () { fallbackCopy(code, succeed); });
        } else {
          fallbackCopy(code, succeed);
        }
      });
    }

    /* ── Bind: upgrade toggles → update shared state ── */
    resInner.querySelectorAll('.ftb-pf__upgrade').forEach(function (row) {
      row.addEventListener('click', function () {
        row.classList.toggle('is-checked');
        var key = row.dataset.key;
        if (key) {
          if (row.classList.contains('is-checked')) {
            if (activeUpgrades.indexOf(key) === -1) activeUpgrades.push(key);
          } else {
            activeUpgrades = activeUpgrades.filter(function (k) { return k !== key; });
          }
        }
        updateResultsState();
      });
    });

    /* ── Bind: ATC (sticky + inline) — both delegate to shared fireAtc() ── */
    var atcBtn       = document.getElementById('ftb-pf-atc');
    var atcInlineBtn = document.getElementById('ftb-pf-atc-inline');
    if (atcBtn)       atcBtn.addEventListener('click',       function () { fireAtc(this); });
    if (atcInlineBtn) atcInlineBtn.addEventListener('click', function () { fireAtc(this); });

    /* ── Bind: restart ── */
    var restBtn = document.getElementById('ftb-pf-restart');
    if (restBtn) {
      restBtn.addEventListener('click', function () {
        setStage('landing');
        answers        = {};
        currentQ       = 0;
        advancing      = false;
        activeKit      = [];
        activeUpgrades = [];
        resultsEl.style.display = 'none';
        heroEl.style.display    = '';
        if (progFill)  progFill.style.width  = '0%';
        if (progLabel) progLabel.textContent = 'Question 1 of ' + QUESTIONS.length;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* ── Initial dynamic render ── */
    updateResultsState();
  }

  /* ── Central state update — called after every kit change ── */
  function updateResultsState() {
    var allSelected = activeKit.concat(activeUpgrades);

    /* Re-render core cards with remove buttons */
    var cardsWrap = document.getElementById('ftb-pf-cards-wrap');
    if (cardsWrap) {
      var ch = '';
      activeKit.forEach(function (k) { ch += cardHtml(k, true); });
      if (!ch) {
        ch = '<p class="ftb-pf__empty-kit" style="color:var(--ftb-muted);padding:16px 0;grid-column:1/-1;font-size:13px;">All products removed. Tick upgrades below or start over.</p>';
      }
      cardsWrap.innerHTML = ch;
      /* Re-bind remove buttons each render */
      cardsWrap.querySelectorAll('[data-remove-key]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var key = btn.dataset.removeKey;
          activeKit = activeKit.filter(function (k) { return k !== key; });
          updateResultsState();
        });
      });
    }

    /* Update count */
    var countEl = document.getElementById('ftb-pf-kit-count');
    if (countEl) {
      var t = allSelected.length;
      countEl.textContent = t + ' ' + (t === 1 ? 'product' : 'products') + ' in your kit';
    }

    /* Re-render how-to steps */
    var stepsWrap = document.getElementById('ftb-pf-steps-wrap');
    if (stepsWrap) {
      var steps = buildSteps(allSelected);
      var sh = '';
      steps.forEach(function (s) {
        sh += '<div class="ftb-pf__step"><span class="ftb-pf__step-num">' + s.n + '</span><span class="ftb-pf__step-text">' + esc(s.t) + '</span></div>';
      });
      stepsWrap.innerHTML = sh || '<p style="color:var(--ftb-muted);font-size:13px;">Add products to see your wash routine.</p>';
    }

    /* ATC button state — sticky + inline, don't override in-progress states */
    ['ftb-pf-atc', 'ftb-pf-atc-inline'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      if (!btn.disabled) {
        if (activeKit.length === 0 && activeUpgrades.length === 0) {
          btn.disabled    = true;
          btn.textContent = 'Add at least one product to continue';
        } else {
          btn.textContent = 'Add My Kit To Basket';
        }
      }
      if (btn.disabled && (activeKit.length > 0 || activeUpgrades.length > 0)) {
        if (btn.textContent === 'Add at least one product to continue') {
          btn.disabled    = false;
          btn.textContent = 'Add My Kit To Basket';
        }
      }
    });
  }

  /* ── HTML builders ── */
  function cardHtml(k, removable) {
    var info = INFO[k];
    var p    = PD[k] || {};
    var img  = p.img
      ? '<div class="ftb-pf__card-img"><img src="' + esc(p.img) + '" alt="' + esc(info.name) + '" loading="lazy"></div>'
      : '<div class="ftb-pf__card-img"><div class="ftb-pf__card-placeholder">' + info.icon + '</div></div>';
    var removeBtn = removable
      ? '<button type="button" class="ftb-pf__card-remove" data-remove-key="' + k + '" aria-label="Remove ' + esc(info.name) + '">&#x2715;</button>'
      : '';
    return '<div class="ftb-pf__card" data-card-key="' + k + '">' + img +
      '<div class="ftb-pf__card-body">' +
      removeBtn +
      '<p class="ftb-pf__card-name">' + esc(info.name) + '</p>' +
      '<p class="ftb-pf__card-desc">' + esc(info.desc) + '</p>' +
      (p.price ? '<p class="ftb-pf__card-price">' + esc(p.price) + '</p>' : '') +
      '</div></div>';
  }

  function upgradeHtml(k) {
    var info  = INFO[k];
    var p     = PD[k] || {};
    var thumb = p.img
      ? '<div class="ftb-pf__upgrade-thumb"><img src="' + esc(p.img) + '" alt="' + esc(info.name) + '" loading="lazy"></div>'
      : '';
    return '<div class="ftb-pf__upgrade" data-vid="' + (p.id || '') + '" data-key="' + k + '">' +
      '<div class="ftb-pf__upgrade-cb"></div>' +
      thumb +
      '<div class="ftb-pf__upgrade-info">' +
      '<p class="ftb-pf__upgrade-name">' + esc(info.name) + '</p>' +
      '<p class="ftb-pf__upgrade-desc">' + esc(info.desc) + '</p>' +
      '</div>' +
      (p.price ? '<span class="ftb-pf__upgrade-price">' + esc(p.price) + '</span>' : '') +
      '</div>';
  }

  /* ── Why text ── */
  function buildWhy(coreKit, ans) {
    var lines = [];
    if (ans.experience === 'beginner')      lines.push('Kept simple and safe — works perfectly straight out of the bottle.');
    if (ans.protection === 'coated')        lines.push('Every product here is safe for ceramic-coated paintwork.');
    if (coreKit.indexOf('cyclops_pro') !== -1) lines.push('Cyclops Pro lifts the heavy grime before you touch the paint.');
    if (coreKit.indexOf('yeti_pro') !== -1)    lines.push('Yeti Pro foam clings and encapsulates dirt safely.');
    if (coreKit.indexOf('hydra') !== -1)       lines.push('Hydra gives 3-month protection in under 5 minutes.');
    if (coreKit.indexOf('chimera') !== -1)     lines.push('Chimera tops your ceramic coating and restores the slick feel.');
    if (coreKit.indexOf('griffin') !== -1)     lines.push('Griffin leaves a protective gloss layer after every wash.');
    if (ans.frustration === 'brake_dust')   lines.push('Vampire and Vulture are matched to your brake dust issue.');
    if (!lines.length)                      lines.push('This kit covers all the FTB fundamentals for a proper wash routine.');
    return lines.slice(0, 4);
  }

  /* ── How-to steps — built dynamically from selected products ── */
  function buildSteps(selected) {
    var steps = [];
    var n = 1;
    function pad(i) { return i < 10 ? '0' + i : '' + i; }
    function has(k) { return selected.indexOf(k) !== -1; }

    /* 1. Pre-rinse / citrus pre-wash */
    if (has('cyclops_pro')) {
      var cpNote = has('pump_sprayer') ? ' Use the pump sprayer to apply pre-wash products more easily and consistently around the vehicle. Ideal for applying Cyclops evenly before rinsing.' : '';
      steps.push({ n: pad(n++), t: 'Rinse the vehicle. Apply Cyclops Pro to panels, wheels and arches as a citrus pre-wash. Leave 3–5 min then rinse.' + cpNote });
    } else {
      steps.push({ n: pad(n++), t: 'Rinse the vehicle from top to bottom.' });
    }

    /* 2. Snow foam */
    if (has('yeti_pro')) {
      var foamNote = has('foam_lance') ? ' Apply through the FTB Foam Lance for full coverage.' : '';
      steps.push({ n: pad(n++), t: 'Apply Yeti Pro snow foam from bottom to top.' + foamNote + ' Dwell 3–5 minutes then rinse fully.' });
    }

    /* 3. Contact wash */
    if (has('ogre')) {
      var ogNote = has('wash_brick') ? ' Use the FTB Wash Brick.' : ' Use a clean wash mitt.';
      steps.push({ n: pad(n++), t: 'Dilute Ogre in a clean bucket.' + ogNote + ' Work top to bottom in straight lines, rinsing each panel as you go.' });
    } else if (has('satan')) {
      var satNote = has('wash_brick') ? ' Use the FTB Wash Brick.' : ' Use a clean wash mitt.';
      steps.push({ n: pad(n++), t: 'Dilute Satan in a clean bucket.' + satNote + ' Work top to bottom. Do not use on ceramic-coated paint.' });
    }

    /* 4. Decontamination and wheels */
    if (has('vulture')) {
      steps.push({ n: pad(n++), t: 'Apply Vulture to cool wheels and lower panels. Watch for the colour-change reaction as iron contamination dissolves. Rinse off. Use periodically, not every wash.' });
    }
    if (has('vampire')) {
      steps.push({ n: pad(n++), t: 'Apply Vampire to cool wheels. Agitate with a wheel brush then rinse. Never spray onto hot brakes or calipers.' });
    }

    /* 5. Paint correction — before protection */
    if (has('cerburus')) {
      steps.push({ n: pad(n++), t: 'Apply Cerburus to clean dry paintwork panel by panel. Work in and buff off to refine the surface before applying protection.' });
    }

    /* 6. Final rinse and dry */
    var dryNote = has('drying_towel')
      ? ' Dry the vehicle using the FTB large drying towel in straight lines.'
      : ' Dry the vehicle with a clean, soft drying towel or microfibre drying towel in straight lines.';
    steps.push({ n: pad(n++), t: 'Final rinse from top to bottom.' + dryNote });

    /* 7. Protection */
    if (has('hydra')) {
      steps.push({ n: pad(n++), t: 'Apply Hydra through a foam lance or pump sprayer onto a wet vehicle, allow it to dwell briefly, then rinse thoroughly. No buffing required.' });
    }
    if (has('chimera')) {
      steps.push({ n: pad(n++), t: 'Mist Chimera onto a clean dry panel and buff. Tops your ceramic coating and restores the slick feel.' });
    }
    if (has('griffin')) {
      steps.push({ n: pad(n++), t: 'Mist Griffin onto dry paintwork panel by panel and buff for a layer of gloss and light protection.' });
    }
    if (has('goblin')) {
      steps.push({ n: pad(n++), t: 'Work Goblin show glaze panel by panel and buff off for a deep wet-look finish.' });
    }

    /* 8. Tyres and trim */
    if (has('bigfoot')) {
      var bfNote = has('tyre_brush') ? ' Work into the tyre wall using the FTB Tyre Brush.' : '';
      steps.push({ n: pad(n++), t: 'Apply Bigfoot to clean tyres and plastic trim.' + bfNote + ' Allow to cure before driving.' });
    }

    /* 9. Interior */
    if (has('buffalo') && has('bison')) {
      steps.push({ n: pad(n++), t: 'Clean leather with Buffalo then condition with Bison. Work into the grain and buff off.' });
    } else if (has('buffalo')) {
      steps.push({ n: pad(n++), t: 'Apply Buffalo to leather surfaces, work in and wipe off.' });
    } else if (has('bison')) {
      steps.push({ n: pad(n++), t: 'Condition leather with Bison after cleaning. Work into the grain and buff off.' });
    }
    if (has('oni')) {
      steps.push({ n: pad(n++), t: 'Apply Oni to interior plastics and trim as a light dressing and cleaner. Do not use on leather.' });
    }

    return steps;
  }

  /* ── Helpers ── */
  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fallbackCopy(text, onSuccess) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { if (document.execCommand('copy')) onSuccess(); } catch (e) {}
    document.body.removeChild(ta);
  }

}());
